import { Component } from "@angular/core";
import { GameService } from "../../../../../shared/services/game.service";
import { MessageService } from "../../../../../shared/services/message.service";
import { takeUntil } from "rxjs/operators";
import { State } from "src/app/shared/interfaces/state.interface";

@Component({
  selector: "bottom-bar",
  templateUrl: "./bottom-bar.component.html",
  styleUrls: ["./bottom-bar.component.scss"],
})
export class BottomBarComponent {
  private gameState: State;

  constructor(
    private gameService: GameService,
    private messageService: MessageService
  ) {
    this.gameService.stateUpdateReceived$
      .pipe(takeUntil(this.gameService.onDestroy$))
      .subscribe((newState: State) => {
        this.gameState = newState;
      });
  }

  public votesCasted(): boolean {
    return this.gameState.Votes.some((vote) => vote.Card != null);
  }

  async showVotes() {
    if (this.checkIsAlone() || !this.votesCasted()) {
      return;
    }

    await this.gameService.showVotes().catch(() => {
      this.messageService.showError(
        "Er is iets fout gegaan bij het bekijken van de stemming, herlaad de pagina en probeer het opnieuw"
      );
    });
  }

  disableShowVotesCheck() {
    return this.checkIsAlone() || !this.votesCasted();
  }

  checkHasVoted() {
    return this.gameService.hasVoted;
  }

  checkIsAlone() {
    return this.gameService.isAlone;
  }

  getState() {
    return this.gameService.gameState;
  }
}
